import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Award, ShoppingBag, FileCheck } from 'lucide-react';
import ProductCard from '../components/ProductCard';
import { useProducts } from '../contexts/ProductContext';
const Home: React.FC = () => {
  const {
    products
  } = useProducts();
  const featuredProducts = products.slice(0, 3);
  return <div className="bg-gray-50 w-full" data-id="element-83">
      {/* Hero Section */}
      <div className="bg-brand-700 text-white" data-id="element-84">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-85">
          <div className="md:flex md:items-center md:justify-between" data-id="element-86">
            <div className="md:w-1/2" data-id="element-87">
              <h1 className="text-4xl font-extrabold tracking-tight md:text-5xl" data-id="element-88">
                Nutrition Products
                <br data-id="element-89" />
                Recommended by
                <br data-id="element-90" />
                Fay Dietitians
              </h1>
              <p className="mt-4 text-lg text-brand-100 max-w-xl" data-id="element-91">
                Discover products and services that are reviewed, tested, and
                approved by registered dietitians.
              </p>
              <div className="mt-8 flex flex-wrap gap-4" data-id="element-92">
                <Link to="/products" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md bg-white text-brand-700 hover:bg-brand-50" data-id="element-93">
                  Browse Products
                  <ArrowRight className="ml-2 -mr-1 h-5 w-5" data-id="element-94" />
                </Link>
                <Link to="/submit-product" className="inline-flex items-center justify-center px-5 py-3 border border-white text-base font-medium rounded-md text-white hover:bg-brand-600" data-id="element-95">
                  For Dietitians
                </Link>
              </div>
            </div>
            <div className="hidden md:block md:w-1/2" data-id="element-96">
              <img src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?q=80&w=2853&auto=format&fit=crop" alt="Healthy food assortment" className="w-full h-auto rounded-lg shadow-lg" data-id="element-97" />
            </div>
          </div>
        </div>
      </div>
      {/* Featured Products Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-98">
        <div className="flex items-center justify-between mb-8" data-id="element-99">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-100">
            Featured Products
          </h2>
          <Link to="/products" className="text-brand-600 hover:text-brand-700 flex items-center" data-id="element-101">
            View all products
            <ArrowRight className="ml-1 h-4 w-4" data-id="element-102" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-103">
          {featuredProducts.map(product => <ProductCard key={product.id} product={product} featured data-id="element-104" />)}
        </div>
      </div>
      {/* How It Works Section */}
      <div className="bg-white py-12" data-id="element-105">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
          <div className="text-center mb-12" data-id="element-107">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-108">
              How FayMarket Works
            </h2>
            <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-109">
              We connect consumers with products that have been thoroughly
              reviewed by nutrition professionals.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-110">
            <div className="text-center p-6" data-id="element-111">
              <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-brand-100 text-brand-600 mb-4" data-id="element-112">
                <Award className="h-6 w-6" data-id="element-113" />
              </div>
              <h3 className="text-xl font-medium text-gray-900 mb-2" data-id="element-114">
                Expert Reviews
              </h3>
              <p className="text-gray-600" data-id="element-115">
                Every product is thoroughly evaluated by registered dietitians
                for nutritional quality and efficacy.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-116">
              <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-brand-100 text-brand-600 mb-4" data-id="element-117">
                <ShoppingBag className="h-6 w-6" data-id="element-118" />
              </div>
              <h3 className="text-xl font-medium text-gray-900 mb-2" data-id="element-119">
                Find Quality Products
              </h3>
              <p className="text-gray-600" data-id="element-120">
                Browse our curated selection of nutritional products and
                services with confidence.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-121">
              <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-brand-100 text-brand-600 mb-4" data-id="element-122">
                <FileCheck className="h-6 w-6" data-id="element-123" />
              </div>
              <h3 className="text-xl font-medium text-gray-900 mb-2" data-id="element-124">
                Dietitian Submissions
              </h3>
              <p className="text-gray-600" data-id="element-125">
                Registered dietitians can submit products they recommend for
                inclusion in our marketplace.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* CTA Section */}
      <div className="bg-brand-50 py-12" data-id="element-126">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-127">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-128">
            Are you a registered dietitian?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-129">
            Help your clients find quality nutrition products by submitting your
            trusted recommendations to our marketplace.
          </p>
          <Link to="/submit-product" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-brand-600 hover:bg-brand-700" data-id="element-130">
            Submit a Product
          </Link>
        </div>
      </div>
    </div>;
};
export default Home;